export enum DrawerOpenState {
  Closed = 0,
  Open = 1,
  Pinned = 2
}
